export default __webpack_public_path__ + "static/media/logo.848d8aaa.svg";